import { Route } from "@angular/router";
import { UserComponent } from "./user.component";
import { UserListRouting } from "./user-list/user-list-routing";
import { UserEditRouting } from "./user-edit/users-edit-routing";
import { UserEditComponent } from "./user-edit/user-edit.component";
import { Permissions } from "../../../access/shared/authorization/permissions";

export const UserRouting: Route = {
    path: "users",
    component: UserComponent,
    children: [        {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
        {
            path:'create',
            component: UserEditComponent,
            data: {
                breadcrumb: "Création"
            }
        },
        UserListRouting,
        UserEditRouting
    ],
    data:{
        'role':[
            Permissions.ROLE_ADMINISTRATION,
            Permissions.ROLE_ADMIN_GLOBAL,
            Permissions.ROLE_ADMIN_SITE,
            Permissions.ROLE_ADMIN_DISTRI
        ],
        breadcrumb: "Paramètres utilisateur"
    },
}
